"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerCare = exports.CustomerCareProvider = exports.CustomerCareContext = void 0;
const react_1 = __importStar(require("react"));
const CustomerCareContext = (0, react_1.createContext)(undefined);
exports.CustomerCareContext = CustomerCareContext;
function CustomerCareProvider(props) {
    return (react_1.default.createElement(CustomerCareContext.Provider, { value: {} }, props.children));
}
exports.CustomerCareProvider = CustomerCareProvider;
function useCustomerCare() {
    const customerCare = (0, react_1.useContext)(CustomerCareContext);
    if (!customerCare)
        throw new Error("useCustomerCare must be used within a CustomerCareProvider");
    return customerCare;
}
exports.useCustomerCare = useCustomerCare;
//# sourceMappingURL=CustomerCare.js.map